import {InputPasswordCustom} from "../../components";
import {useContext, useState} from "react";
import {UserApi} from "../../apis";
import {useLocation, useNavigate} from "react-router";
import {LoadingContext, PageContext, ToastContext, UserContext} from "../../contexts";
import {FaUsers} from "react-icons/fa";

export const UserSenha = () => {
  const location = useLocation();
  const {user} = useContext(UserContext);
  const {setLoading} = useContext(LoadingContext);
  const {pageInfo, setPageInfo} = useContext(PageContext);
  const [count, setCount] = useState(0);

  // const [senhaOld, setSenhaOld] = useState('');
  // const [helperSenhaOld, setHelperSenhaOld] = useState('');
  // const [errorSenhaOld, setErrorSenhaOld] = useState(false);

  const [senhaNova, setSenhaNova] = useState('');
  const [helperSenhaNova, setHelperSenhaNova] = useState('');
  const [errorSenhaNova, setErrorSenhaNova] = useState(false);

  const [senhaRepetida, setSenhaRepetida] = useState('');
  const [helperSenhaRepetida, setHelperSenhaRepetida] = useState('');
  const [errorSenhaRepetida, setErrorSenhaRepetida] = useState(false);

  const navigate = useNavigate();

  const toasts = useContext(ToastContext);
  const AddToast = (item) => {
    let tempArr = [...toasts.toast];
    tempArr.push(item);
    toasts.setToast({toast: tempArr, setToast: toasts.setToast});
  }


  const validarCampos = () => {
    // setErrorSenhaOld(false);
    setErrorSenhaNova(false);
    setErrorSenhaRepetida(false);

    // if (senhaOld === "") {
    //   setHelperSenhaOld('O Campo não pode estar vazio');
    //   setErrorSenhaOld(true);
    //   return false;
    // }
    if (senhaNova === "") {
      setHelperSenhaNova('O Campo não pode estar vazio');
      setErrorSenhaNova(true);
      return false;
    }
    if (senhaRepetida === "") {
      setHelperSenhaRepetida('O Campo não pode estar vazio');
      setErrorSenhaRepetida(true);
      return false;
    }
    if (senhaNova !== senhaRepetida) {
      setHelperSenhaNova('As senhas devem ser iguais');
      setErrorSenhaNova(true);
      setHelperSenhaRepetida('As senhas devem ser iguais');
      setErrorSenhaRepetida(true);
      return false;
    }

    return true;
  }

  const sendSenha = async () => {
    setLoading(true);
    if (location.state.uuid) {
      if (validarCampos()) {
        try {
          let resultadoSenhaSave = await UserApi.updateSenha(user.uuid, location.state.uuid, senhaNova);
          if (!resultadoSenhaSave.error) {
            setLoading(false);
            AddToast({texto:"Alterado!", tipo: "sucesso"});
            navigate('/portalcolaborador/inicio');
          } else {
            setLoading(false);
            AddToast({texto:resultadoSenhaSave.error, tipo: "erro"});
          }
        } catch (e) {
          AddToast({texto:e, tipo: "erro"});
          setLoading(false);
        }
      }
    } else {
      setLoading(false);
      AddToast({texto:"Falha ao identificar o usuário!", tipo: "erro"});
      navigate('/portalcolaborador/inicio');
    }
    setLoading(false);
  }

  if (count < 1) {
    setPageInfo(
      {
        ...pageInfo,
        titulo: 'Usuários',
        icone: <FaUsers size={30}/>
      }
    );
    setCount(count + 1);
  }

  return (
    <div className="user painel-itens">
      <h2 className="titulo">Editar usuário</h2>
      <div className="form-usuario d-flex direction-column">

        {/*<InputPasswordCustom*/}
        {/*  label="Senha antiga"*/}
        {/*  value={senhaOld}*/}
        {/*  onChange={(e) => setSenhaOld(e.target.value)}*/}
        {/*  helperText={helperSenhaOld}*/}
        {/*  error={errorSenhaOld}*/}
        {/*/>*/}

        <InputPasswordCustom
          label="Nova senha"
          value={senhaNova}
          onChange={(e) => setSenhaNova(e.target.value)}
          helperText={helperSenhaNova}
          error={errorSenhaNova}
        />

        <InputPasswordCustom
          label="Repetir nova senha"
          value={senhaRepetida}
          onChange={(e) => setSenhaRepetida(e.target.value)}
          helperText={helperSenhaRepetida}
          error={errorSenhaRepetida}
          onKeyPress={(e) => {
            if (e.key === 'Enter') sendSenha()
          }}
        />

        <div className="d-flex justify-end">
          <div className="btn btn-cancelar" onClick={() => navigate(-1)}>
            Cancelar
          </div>
          <div className="btn btn-enviar" onClick={sendSenha}>
            Salvar
          </div>
        </div>
      </div>
    </div>
  );
}